import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import MenuTool from "../../components/Toolnav/MenuTool";
import { useQuery } from "@tanstack/react-query";
import { handleFetchTrainings } from "../../api/training";

export default function Dashboard() {
  const { data: trainings } = useQuery({
    queryKey: ["trainings"],
    queryFn: handleFetchTrainings,
  });

  return (
    <div className="">
      <MenuTool menus={[{ id: 1, name: "Calendar", to: "/dashboard" }]} />
      <div className="p-4 h-auto bg-white">
        <FullCalendar
          plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
          initialView="dayGridMonth"
          headerToolbar={{
            left: "prev,next today",
            center: "title",
            right: "dayGridMonth,timeGridWeek,timeGridDay",
          }}
          events={trainings?.payload}
        />
      </div>
    </div>
  );
}
